//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixins from './mixins'
import { getAnsweredQuestions } from './const'
export default {
    mixins: [mixins],
    data () {
        return {
            items: getAnsweredQuestions()
        }
    }
}
